export default __webpack_public_path__ + "static/media/10.2543d573.JPG";